import { forwardRef } from 'react';
import COutlinedInput from '../input/outlined-input';
import { ICAutocomplete } from 'types/molecules';
import { CMenuItem } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { Autocomplete, CircularProgress } from '@mui/material';
import { ReactComponent as ArrowDownSvg } from 'assets/svg/arrow-down.svg';

const CAutocomplete = forwardRef<HTMLDivElement, ICAutocomplete>((props, ref) => {
  const {
    options,
    isLoading,
    onChange,
    onBlur,
    name,
    multiple,
    label,
    required,
    error,
    helperText,
    className,
    disabled,
    value,
    ...rest
  } = props;
  const { t } = useTranslation('common');

  return (
    <Autocomplete
      {...rest}
      ref={ref}
      aria-required={required}
      multiple={multiple}
      className={className}
      value={value}
      onBlur={(e) => onBlur && onBlur(e)}
      renderOption={({ className, ...restOfProps }, option) => (
        <CMenuItem {...restOfProps} key={option.value}>
          {option.label}
        </CMenuItem>
      )}
      disabled={disabled}
      isOptionEqualToValue={(option, selected) => option.value === selected.value}
      getOptionLabel={(option) => option.label}
      options={options || []}
      loadingText={t('loading')}
      noOptionsText={t('no-options')}
      loading={isLoading}
      popupIcon={<ArrowDownSvg className="text-neutral-400" />}
      onChange={(event, value, reason, details) => {
        onChange(event, value, reason, details);
      }}
      renderInput={(params) => (
        <COutlinedInput
          {...params}
          name={name}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          InputLabelProps={{
            ...params.InputLabelProps,
            classes: {
              root: 'text-neutral-400',
            },
          }}
          // eslint-disable-next-line tailwindcss/no-custom-classname
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
            classes: {
              root: `min-h-[48px] ${disabled ? '' : 'bg-white'}`,
            },
            size: 'small',
          }}
        />
      )}
    />
  );
});

export default CAutocomplete;
